const React = require('react');
const Ripple = require('../Ripple');


module.exports = (props) => {
  const {
    label,
    onChange,
    checked,
    error,
  } = props;
  const disabled = props.disabled || false;

  function handleClick(e) {
    e.stopPropagation();
    !disabled && onChange && onChange(!checked);
  }

  return (
    <div className={props.className || ''}>
      <div className="layoutRow fhaS fvaC h45">
        <Ripple
          className={`layoutRow fhaC fvaC c5B47FF w(|min)60 h32 rlv r16 ov bs
            b1 bc0.5 dn bc0:h:not(:disabled)` + (error ? ' error' : '')}
          disabled={disabled}
          onClick={handleClick}
        >
          <div
            className={`sl4 st3 abs r sq24 dn bgC bgB<1:h (bgC).disabled<1:h
              (sl30|bg5B47FF|bg4B37EF<1:h!).checked`
              + (checked ? ' checked' : '')
              + (disabled ? ' disabled' : '')
            }
          />
        </Ripple>
        {
          label ? (<div
            className={`ml15 f12 lh18 ff$3 usN lts0em fw3 ${label && label.className || ''}`}
            onClick={handleClick}
          >
            {label.name || ''}
          </div>) : null
        }
        {props.children || null}
      </div>
      {
        error ? (<div className="rlv">
          <div
            className="abs sh25 st f11 cF00 fw4"
          >{props.helperText || 'Obligatory field'}</div>
        </div>) : null
      }
    </div>
  );
};
